import handleIframeForms from "../components/handle-iframe-form";
import waitForGlobal from "../components/wait-for-global";

waitForGlobal("MktoForms2", handleIframeForms);
